module.exports = __webpack_public_path__ + "static/media/washbasin-bath.0c218bc3.png";